
function showMessageBox(type, message, extra) {
    var boxType = type;
    var content = '';
    var topMessage = ''
    if (extra) {
        content = '<div>' + extra.content + '</div>';
    }
    if (boxType == 'danger') {
        topMessage = "ERROR"
    } else {
        topMessage = "SUCCESS"
    }
    var messageBox = '<div class="alert-container fade in relative"><div class="alert-' + boxType + '"><img id="close-error" class="close-sample" src="/skins/current-skin/images/icons/cancel.svg" alt="close" loading="lazy"></img><img class="alert-image" src="/skins/current-skin/images/icons/' + boxType + '.svg" alt="icon" loading="lazy"></img><div class="alert">' + message + content + '!</div></div></div>';
    $('div.alert-box').html(messageBox);
    $('#close-error').on('click', function () {
        $('div.alert-box').html('');
        $('.alert-box').hide()
        $('body').removeClass('block-scroll')
    });
    $('body').addClass('block-scroll')
    $('.alert-box').show();
    setTimeout(function () {
        $('div.alert-box').html('');
        $('.alert-box').hide();
        $('body').removeClass('block-scroll')
    }, 3000);

}

function showQuestionBox(message, extra, action) {
    // Build optional extra content element
    let extraEl = null;
    if (extra) {
        extraEl = document.createElement('div');
        extraEl.textContent = extra.content;
    }

    // Close handler — clears the box and restores scroll
    function closeBox() {
        $('div.alert-box').html('');
        $('.alert-box').hide();
        $('body').removeClass('block-scroll');
    }

    // --- Build DOM structure ---

    const alertBox = $('<div>', { class: 'alert-container fade in relative' });
    const alertInner = $('<div>', { class: 'alert-danger' });

    const closeIcon = $('<img>', {
        id: 'close-error',
        class: 'close-sample',
        src: '/skins/current-skin/images/icons/cancel.svg',
        alt: 'close',
        loading: 'lazy',
    });

    const dangerIcon = $('<img>', {
        class: 'alert-image',
        src: '/skins/current-skin/images/icons/danger.svg',
        alt: 'danger',
        loading: 'lazy',
    });

    const alertContent = $('<div>', { class: 'alert' }).text(message);
    if (extraEl) alertContent.append(extraEl);

    const buttonRow = $('<div>', { class: 'flex mt-16' });

    const cancelBtn = $('<input>', {
        type: 'button',
        class: 'btn btn-third width-100 mr-8 close-button',
        value: 'Annulla',
    });

    const confirmBtn = $('<input>', {
        type: 'button',
        class: 'btn btn-primary width-100 ml-8',
        value: 'Conferma',
    });

    // Attach action as a proper function, not an inline string
    confirmBtn.on('click', function () {
        action();
        closeBox();
    });

    cancelBtn.on('click', closeBox);
    closeIcon.on('click', closeBox);

    // --- Assemble & render ---

    buttonRow.append(cancelBtn, confirmBtn);
    alertInner.append(closeIcon, dangerIcon, alertContent, buttonRow);
    alertBox.append(alertInner);

    $('div.alert-box').html('').append(alertBox);
    $('body').addClass('block-scroll');
    $('.alert-box').show();
}

$(document).ready(function () {

    var errorFound = getUrlParam("error");

    if (errorFound) {
        $('body').addClass('block-scroll')
        $('.alert-box').show();
        $('.close-sample').on('click', function () {
            $('div.alert-box').html('');
            $('.alert-box').hide();
            $('body').removeClass('block-scroll')
        });
        setTimeout(function () {
            $('div.alert-box').html('');
            $('.alert-box').hide();
            $('body').removeClass('block-scroll')
        }, 3000);
    }

});